import React from "react";

export const AuthStatusChanged = React.createContext(null);
